module.exports = __webpack_public_path__ + "img/new-doc-icon-dark.f5a6ad12.svg";